// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__Kn4tv","inputWrap":"Table_inputWrap__3T5CM","col":"Table_col__2uvti","bmiTooltip":"Table_bmiTooltip__1iovD"};